export const edgePadFactor = 0.035;


// WEBPACK FOOTER //
// ./js/styles/styles.jsx